import React from 'react';

import { CardExpiryElement } from '@stripe/react-stripe-js';
import type { StripeCardExpiryElementChangeEvent } from '@stripe/stripe-js';

type Props = {
	onChange?: (event: StripeCardExpiryElementChangeEvent) => unknown;
	onFocus?: () => void;
	onBlur?: () => void;
};

export const CardExpiryElementWrapper: React.FC<Props> = ({ onChange, onFocus, onBlur }) => {
	return (
		<CardExpiryElement
			options={{ style: { base: { fontSize: '16px' } } }}
			onChange={onChange}
			onFocus={onFocus}
			onBlur={onBlur}
		/>
	);
};
